import React, { useEffect, useState } from 'react';
import { __ } from '@wordpress/i18n';

// store
import { storeSet, useStoreValue } from '../../store';

// components
import LogoIcon from '../../icons/LogoIcon';
import { useForm } from 'react-hook-form';
import FormField from '../../components/FormField';
import ButtonFormSubmit from '../../components/ButtonWrapper/components/ButtonFormSubmit';
import { NavLink, useNavigate, useSearchParams } from 'react-router-dom';
import { isEmpty, isNil } from 'ramda';
import FbIcon from '../../icons/FbIcon';
import GoogleIcon from '../../icons/GoogleIcon';

const Login = () => {
    const navigate = useNavigate();
    const token = useStoreValue('token');
    const [loading, setLoading] = useState(false);
    //const [isMaintenance, setIsMaintenance] = useState(false);
    const [searchParams] = useSearchParams();
    const {
        control,
        handleSubmit,
        formState: { isValid }
    } = useForm({ mode: 'onChange' });

    const onSubmit = async (formData) => {
        setLoading(true);

        try {
            await storeSet('login', formData);
            navigate('/projects');
        } catch (error) {
            // Error already displayed by store action
        } finally {
            setLoading(false);
        }
    };

    const handleGoToRegistration= () => {
        navigate('/registration');
    }

    // Email validation rules
    const emailValidationRules = {
        required: __('Email is required', 'soundbetween'),
        pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: __('Enter a valid email', 'soundbetween')
        }
    };

    // Password validation rules
    const passwordValidationRules = {
        required: __('Password is required', 'soundbetween')
    };

    /*useEffect(() => {
        if (isMaintenance) {
            /!*if (errorMsgs.current) {
                errorMsgs.current.show([
                    {
                        sticky: true, severity: 'info', summary: '',
                        detail: __('Piattaforma in manutenzione', 'soundbetween'),
                        closable: false
                    }
                ]);
            }*!/
        }
    }, [isMaintenance]);*/

    useEffect(() => {
        const queryParams = Object.fromEntries(searchParams);

        if (!isEmpty(token) && isNil(queryParams.redirectReason)) {
            window.location.replace('/projects');
        }
    }, [token]);

    return (
        <div className={['appPage', 'appPageLogin'].join(' ')}>
            <div className="appPageLogin__wrapper">

                <LogoIcon/>

                <div className="loginCard">
                    <span className="loginCard__title">{__('Benvenuto!', 'soundbetween')}</span>
                    <span className="loginCard__subttitle">
                        {__('Login to start collaborating, creating and sharing', 'soundbetween')}
                    </span>

                    <form className="appForm" onSubmit={handleSubmit(onSubmit)} noValidate>
                        <fieldset>
                            <FormField
                                type="email"
                                name="email"
                                placeholder={__('Email', 'soundbetween')}
                                control={control}
                                rules={emailValidationRules}
                            />

                            <FormField
                                type="password"
                                name="password"
                                placeholder={__('Password', 'soundbetween')}
                                control={control}
                                rules={passwordValidationRules}
                                description={<NavLink to="/reset-password">
                                    {__('Forgot your password?', 'soundbetween')}
                            </NavLink>}
                            />
                        </fieldset>

                        <div className="loginCard__socialDivider">
                            <span className="loginCard__socialDivider-line"></span>
                            <span className="loginCard__socialDivider-label">{__('Or', 'soundbetween')}</span>
                            <span className="loginCard__socialDivider-line"></span>
                        </div>

                        <div className="loginCard__socialButtons">
                            <button type="button" className="loginCard__socialBtn">
                                <FbIcon />
                                <span>{__('Facebook', 'soundbetween')}</span>
                            </button>
                            <button type="button" className="loginCard__socialBtn">
                                <GoogleIcon />
                                <span>{__('Google', 'soundbetween')}</span>
                            </button>
                        </div>

                        <ButtonFormSubmit onClick={() => {}} disabled={loading || !isValid}>
                            {__('Confirm', 'soundbetween')}
                        </ButtonFormSubmit>

                        <p className="loginCard__subttitle">
                            {__('No sei registrato? ', 'soundbetween')}
                            <a href="#" onClick={(e) => {
                                e.preventDefault();
                                handleGoToRegistration();
                            }}>
                                {__('Registrati qua', 'soundbetween')}
                            </a>
                        </p>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Login;